<template>
  <div class="my-wrapper">
    <div class="my-header">
      <VanImage
        class="avatar"
        round
        :src="userInfo?.avatar || require('@/assets/images/my/avatar.png')"
      />
      <div class="detail">
        <div v-if="!isEdit" class="username">{{ userInfo?.nickname || '用户'}}</div>
        <input v-if="isEdit" class="username" type="text" v-model="userName">
        <!-- <div class="signature">一起和平行宇宙里的另一个我聊聊天～</div> -->
      </div>
      <div class="edit-data" @click="toEdit">
        {{ isEdit ? '完成' : '编辑资料' }}
      </div>
    </div>
    <div class="card">
      <div class="card-subtitle">
        其他服务
      </div>
      <div class="service-list">
        <div class="service-item">
          <img class="service-icon" src="@/assets/images/my/my_list_1.png" alt="服务图标">
          <a class="service-name" :href="`tel:${hotline}`">危机干预热线  {{hotline}}</a>
          <img class="right-icon" src="@/assets/images/right.png" alt="右箭头">
        </div>
        <template v-for="item in list">
          <div class="service-item" :key="item.value" @click="onClick(item)">
            <img class="service-icon" :src="item.icon" alt="服务图标">
            <div class="service-name">{{item.name}}</div>
            <img class="right-icon" src="@/assets/images/right.png" alt="右箭头">
          </div>
        </template>
        <div>
          <div class="on-btn" @click="loginOut">
            退出登陆
          </div>
        </div>
      </div>
    </div>
    <popup
        v-model="showModal"
    >
      <div class="body">
        <img class="clock-image" src="@/assets/images/clock.png" alt="钟">
        <h3>医生预约</h3>
        <p>选择希望预约的时间段</p>
        <div class="date-select">
          <div class="date-select-left">
            <img class="date-image" src="@/assets/images/time-select.png" alt="时钟">
            <div class="date-title">日期选择</div>
          </div>
          <div class="date-select-right" @click="openPopup">
            <div class="date-val">{{ selectDate | dateFormat('MM月DD日') }}</div>
            <img class="right-icon" src="@/assets/images/right.png" alt="右箭头">
          </div>
        </div>
        <div class="time-list">
          <template v-for="(item, index) in times">
            <div class="time-item"  :class="{selected: isSelected(item.value)}" :key="index" @click="timeClick(item)">{{item.name}}</div>
          </template>
        </div>
        <div class="ok-btn" @click="ok">OK</div>
      </div>
    </popup>
    <year-month-day-popup ref="yearMonthPopupRef" @confirm="onConfirm" />
  </div>
</template>

<script >
import { mapState, mapActions } from 'vuex'
import config from './config'
import {Popup, Toast, Dialog, Image as VanImage } from "vant";
import {removeToken} from "@/utils/auth";
import { getHotline, editUserInfo, setAppointementTime, loginOut } from '@/api/user'
import { dictDataType } from '@/api/app'
import {Form} from '@/components'
const {YearMonthDayPopup} = Form

export default {
  name: 'my',
  components: {
    Popup,
    VanImage,
    YearMonthDayPopup
  },
  data () {
    return {
      showModal: false,
      list: config.list,
      times: [],
      selectTime: null,
      hotline: '',
      userName: '',
      isEdit: false,
      selectDate: new Date()
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  mounted() {
    this.getUserInfoFn();
    this.initData();
  },
  methods: {
    ...mapActions([
      'getUserInfoFn'
    ]),
    async initData() {
      try {
        const hotline = await getHotline();
        dictDataType('booking_time').then(res => {
          console.log(res)
          this.times = res.map(item => {
            return {
              name: item.label,
              value: item.value
            }
          });
        })
        this.hotline = (hotline.cityHotline ? hotline.cityHotline + '-' : '') + hotline.nationalHotline;
      } catch (error) {
        console.log(error)
      }
    },
    onClick(item) {
      if (item.type && item.type === 'button') {
        this.onHandled(item)
        return
      }
    },
    onHandled() {
      this.showModal = true
    },
     loginOut(){
      Dialog.confirm({
        message: '确定要退出吗',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(async () => {
        await loginOut()
        removeToken()
        this.$router.push({
          path: '/login'
        })
      }).catch(() => {
        console.log('')
      });
    },
    isSelected(value) {
      if(this.selectTime) {
        return this.selectTime.value === value
      } else {
        return false;
      }
    },
    timeClick(item) {
      if(this.selectTim && this.selectTim.value === item.value) {
        return;
      }
      console.log(item)
      this.selectTime = item;
    },
    async ok() {
      if (!this.selectTime) {
        Toast.fail('请选择时间段')
      } else {
        const params = {
          appointmentDate: this.$dayjsFormat(this.selectDate),
          appointmentTimeRange: this.selectTime.value
        }
        await setAppointementTime(params);
        Toast('预约成功')
        this.showModal = false
        setTimeout(() => {
          this.selectTime = null
        }, 300)
      }
    },
    async toEdit() {
      if(this.isEdit) {
        const params = {
          nickname: this.userName
        }
        await editUserInfo(params)
        this.getUserInfoFn();
      } else {
        this.userName = this.userInfo.nickname;
      }
      this.isEdit = !this.isEdit;
    },
    openPopup() {
      this.$refs?.yearMonthPopupRef?.open()
    },
    onConfirm (value) {
      this.selectDate = value
    },
  }
}

</script>

<style scoped lang="scss">
.my-wrapper {
  height: 100%;
  padding: 50px 20px;
  box-sizing: border-box;
  background: radial-gradient(87.44% 51.55% at 16.923079571545667% 6.039263930480641%, rgba(226, 239, 255, 1) 0%, rgba(255, 255, 255, 0) 100%, rgba(255, 255, 255, 0) 101%);
}
.my-header {
  box-sizing: border-box;
  position: relative;
  padding: 14px 0;
  width: 100%;
  display: flex;
}
.detail {
  margin-left: 14px;
  flex: 1;
  .username {
    margin-top: 18px;
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 24px;
    color: rgba(18, 18, 18, 1);
    vertical-align: top;
  }
  input {
    background: rgba(255, 255, 255, 1);
    display: flex;
    align-items: center;
    border: none;
    padding: 0 10px;
    box-sizing: border-box;
    &::placeholder {
      color: rgba(0, 0, 0, 0.4);
    }
  }
  .signature {
    margin-top: 4px;
    font-size: 10px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 13.26px;
    color: rgba(146, 156, 172, 1);
    vertical-align: top;
  }
}
.edit-data {
  box-sizing: border-box;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 15.91px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  vertical-align: top;
  border-radius: 36px;
  background: linear-gradient(90deg, rgba(102, 145, 251, 1) 0%, rgba(106, 211, 254, 1) 100%);
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 6px 12px 6px 12px;
  position: absolute;
  top: 0;
  right: 0;
}
.avatar {
  width: 68px;
  height: 68px;
  border-radius: 50%;
  overflow: hidden;
  background: #eee;
}
.card {
  padding: 15px;
  box-sizing: border-box;
  margin-top: 21px;
  border-radius: 8.12px;
  background: rgba(255, 255, 255, 1);
}
.card-subtitle {
  padding: 0 6px;
  position: relative;
  display: inline-block;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 21.22px;
  color: rgba(18, 18, 18, 1);
  text-align: left;
  vertical-align: top;
  z-index: 1;
  margin-bottom: 15px;
}
.card-subtitle::before {
  content: '';
  position: absolute;
  left: 50%;
  bottom: 4px;
  width: 68px;
  height: 8px;
  opacity: 1;
  background: rgba(102, 232, 255, 1);
  transform: translateX(-50%);
  z-index: -1;
}
.service-list {
  border-top: 1px solid rgba(246, 246, 246, 1);
  padding: 15px 0;
  box-sizing: border-box;
}
.service-item {
  display: flex;
  align-items: center;
  padding: 8px;
  box-sizing: border-box;
  margin-bottom: 8px;
}
.service-item:last-child {
  margin-bottom: 0;
}
.service-icon {
  width: 24.35px;
  height: 24.35px;
}
.service-name {
  flex: 1;
  margin: 0 7px;
  font-size: 12.17px;
  font-weight: 400;
  line-height: 17.04px;
  color: rgba(18, 24, 54, 1);
}
.right-icon {
  width: 5px;
  height: 5px;
}

.body {
  box-sizing: border-box;
  width: 240px;
  padding: 21px;
  border-radius: 16.8px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 6.6px 13.8px  rgba(0, 0, 0, 0.18);
  .clock-image {
    display: block;
    width: 133px;
    height: 133px;
    margin: 0 auto 5px;
  }
  h3 {
    margin: 0;
    text-align: center;
    font-size: 20px;
    font-weight: 500;
    line-height: 26.52px;
    color: rgba(27, 105, 253, 1);
    vertical-align: top;
  }
  p {
    margin: 0;
    text-align: center;
    font-size: 10px;
    font-weight: 400;
    line-height: 13.26px;
    color: rgba(128, 128, 128, 1);
    vertical-align: top;
  }
  .date-select {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;
    width: 100%;
    height: 26px;
    border-radius: 3px;
    padding: 0 6px;
    background: rgba(204, 204, 204, 0.17);
    box-sizing: border-box;
    .date-select-left {
      display: flex;
      align-items: center;
    }
    .date-select-right {
      display: flex;
      align-items: center;
    }
    .date-image {
      width: 16px;
      height: 16px;
      margin-right: 6px;
    }
    .date-title {
      font-size: 12px;
      font-weight: 400;
      color: rgba(122, 122, 122, 1);
    }
    .date-val {
      font-size: 12px;
      font-weight: 400;
      color: rgba(59, 59, 59, 1);
      margin-right: 6px;
    }
    .right-icon {
      width: 5px;
      height: 5px;
    }
  }
}
.time-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px 9px;
  margin-top: 19px;
}
.time-item {
  cursor: pointer;
  width: 95px;
  height: 20px;
  opacity: 1;
  border-radius: 60px;
  background: rgba(18, 136, 255, 0.13);
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 20px;
  color: rgba(28, 71, 223, 1);
  text-align: center;
  vertical-align: top;
}
.time-item.selected {
  color: #ffffff;
  background: rgba(27, 105, 253, 1);
}
.ok-btn {
  cursor: pointer;
  width:174px;
  box-sizing: border-box;
  margin: 25px auto 0;
  padding: 9px;
  font-size: 10.8px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 14.75px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  vertical-align: top;
  border-radius: 16.5px;
  background: rgba(27, 105, 253, 1);
  box-shadow: 0px 3.6px 7.2px  rgba(27, 105, 253, 0.39);
}

.on-btn {
  cursor: pointer;
  margin: 30px auto 20px;
  width: 100%;
  height: 45px;
  opacity: 1;
  border-radius: 22.5px;
  background: linear-gradient(90deg, rgba(102, 145, 251, 1) 0%, rgba(106, 211, 254, 1) 100%);
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0.42px;
  line-height: 45px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  vertical-align: top;
}
</style>